import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English translations
import enHeader from "./en/header.json";
import enAbout from "./en/about.json";
import enContact from "./en/contact.json";
import enHome from "./en/homePage.json";
import enMenu from "./en/menu.json";
import enSpecial from "./en/special.json";
import enVdo from "./en/vdo.json";

// Khmer translations
import khHeader from "./kh/header.json";
import khAbout from "./kh/about.json";
import khContact from "./kh/contact.json";
import khHome from "./kh/homePage.json";
import khMenu from "./kh/menu.json";
import khSpecial from "./kh/special.json";
import khVdo from "./kh/vdo.json";

// Chinese translations
import chHeader from "./ch/header.json";
import chAbout from "./ch/about.json";
import chContact from "./ch/contact.json";
import chHome from "./ch/homePage.json";
import chMenu from "./ch/menu.json";
import chSpecial from "./ch/special.json";
import chVdo from "./ch/vdo.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    ns: ["header", "homePage", "about", "contact", "menu", "special", "video"],
    defaultNS: "header",
    resources: {
      en: {
        header: enHeader,
        homePage: enHome,
        about: enAbout,
        contact: enContact,
        menu: enMenu,
        special: enSpecial,
        video: enVdo,
      },
      kh: {
        header: khHeader,
        homePage: khHome,
        about: khAbout,
        contact: khContact,
        menu: khMenu,
        special: khSpecial,
        video: khVdo,
      },
      ch: {
        header: chHeader,
        homePage: chHome,
        about: chAbout,
        contact: chContact,
        menu: chMenu,
        special: chSpecial,
        video: chVdo,
      },
    },
  });

export default i18n;
